<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-11 15:00:18
 * @LastEditors: zouyuping
 * @LastEditTime: 
 * @FilePath:
 * @Description: 自助结账页面
-->
<template>
  <div>
    暂未开放
  </div>
</template>

<script>
export default {
  name: "SelfCheckoutPay",
  props: {

  },
  data() {
    return {

    };
  },
  components: {

  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>
<style scoped lang='scss'>
</style>
